import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { misBaseQuery } from './base-queries/mis-request';

const { app } = PULSE;
const { API_RETRY_COUNT } = app.common.CONSTANTS;

// RTK Query update: Define an api service with a base URL and retry attempts
// RTK Query update: Endpoints can be added here or injected in components
export const cfsCommentaryApi = createApi({
    reducerPath: 'cfsCommentaryAPI',
    baseQuery: retry(misBaseQuery(PULSE.app.environment.cfsCommentary), {
        maxRetries: API_RETRY_COUNT
    }),
    endpoints: (build) => ({
        getComms: build.query({
            query: (id) => `/${id}`,
            transformResponse: (response) => {
                if (response.lastUpdated) {
                    delete response.lastUpdated;
                }
                return response;
            }
        })
    })
});
